module.exports = __webpack_public_path__ + "static/media/mdi_delete_forever.702caf10.svg";